import React from 'react'
import { logUtil } from 'packages/src'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'

import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { showHeaderBannerAction } from 'modules/headerBanner/actions/show/index.js'
import { HEADER_BANNER_ID } from 'modules/headerBanner/constants/index.js'
import { shouldShowNewCustomerDiscountTimerUserSelect } from 'modules/training/modules/training-users/selectors/shouldShowNewCustomerDiscountTimer/index.js'
import { hasNewCustomerDiscountExpiresAtUserSelect } from 'modules/training/modules/training-users/selectors/hasNewCustomerDiscountExpiresAt/index.js'

export function HandleNewCustomerHeaderBanner () {
  const dispatch = useDispatch()
  const shouldShow = useSelector(shouldShowNewCustomerDiscountTimerUserSelect)
  const hasNewCustomerDiscountExpiresAt = useSelector(hasNewCustomerDiscountExpiresAtUserSelect)
  const debugProps = {
    shouldShow,
    hasNewCustomerDiscountExpiresAt
  }
  logUtil('HandleNewCustomerHeaderBanner').debug('[start] debugProps=', debugProps)

  const handleMount = () => {
    if (!shouldShow) {
      return
    }

    if (!hasNewCustomerDiscountExpiresAt) {
      return
    }

    dispatch(
      showHeaderBannerAction({
        id: HEADER_BANNER_ID.NEW_CUSTOMER_DISCOUNT_TIMER
      })
    )
  }

  React.useEffect(() => {
    handleMount()
  }, [
    shouldShow,
    hasNewCustomerDiscountExpiresAt
  ])

  return <></>
}
